 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import useAtmosphere from '~/hooks/useAtmosphere'

import DialogContainer from '../../../../components/DialogContainer'
import DialogContent from '../../../../components/DialogContent'
import DialogTitle from '../../../../components/DialogTitle'
import IconLabel from '../../../../components/IconLabel'
import PrimaryButton from '../../../../components/PrimaryButton'
import useMutationProps from '../../../../hooks/useMutationProps'
import PromoteToTeamLeadMutation from '../../../../mutations/PromoteToTeamLeadMutation'
import {upperFirst} from '../../../../utils/upperFirst'

const StyledDialogContainer = styled(DialogContainer)({
  width: 420
})

const StyledButton = styled(PrimaryButton)({
  margin: '1.5rem auto 0'
})






const PromoteTeamMemberModal = (props) => {
  const atmosphere = useAtmosphere()
  const {submitMutation, submitting, onError, onCompleted} = useMutationProps()
  const {closePortal, teamMember: teamMemberRef} = props
  const teamMember = useFragment(
    graphql`
      fragment PromoteTeamMemberModal_teamMember on TeamMember {
        userId
        teamId
        preferredName
        isSelf
        team {
          isOrgAdmin
          teamLead {
            isSelf
            preferredName
          }
        }
      }
    `,
    teamMemberRef
  )
  const {preferredName, teamId, userId, team, isSelf} = teamMember
  const {isOrgAdmin, teamLead} = _nullishCoalesce(team, () => ( {}))
  const oldLeadName = _nullishCoalesce(_optionalChain([teamLead, 'optionalAccess', _ => _.preferredName]), () => ( ''))
  const isOldLeadSelf = _optionalChain([teamLead, 'optionalAccess', _2 => _2.isSelf])
  const handleClick = () => {
    submitMutation()
    PromoteToTeamLeadMutation(atmosphere, {teamId, userId}, {onError, onCompleted})
    closePortal()
  }

  const copyStart = `Are you sure? ${isOldLeadSelf ? 'You' : oldLeadName} will be removed as the team leader and ${isSelf ? 'you' : preferredName} will be promoted.`
  const copyEnd =
    isOldLeadSelf && isOrgAdmin
      ? ''
      : `${isOldLeadSelf ? 'You' : upperFirst(oldLeadName)} will no longer be able to change team membership.`
  const copy = `${copyStart} ${copyEnd}`

  return (
    React.createElement(StyledDialogContainer, null
      , React.createElement(DialogTitle, null, 'Are you sure?')
      , React.createElement(DialogContent, null
        , copy
        , React.createElement(StyledButton, { size: "medium", onClick: handleClick, waiting: submitting,}
          , React.createElement(IconLabel, { icon: "arrow_forward", iconAfter: true, label: `Yes, promote ${preferredName}`,} )
        )
      )
    )
  )
}

export default PromoteTeamMemberModal
